export default interface IStatusColor {
    fillColor: string;
    textColor: string;
    badgeColor: string;
}